// NB! This entripoint is only rebuilt by
// - yarn run build
// - yarn run dist
// remove this require if you plan to use A-Frame via CDN
import 'aframe/src'
/**
 * require below all external aframe components
 * not your app modules
 */



// WEBPACK FOOTER //
// ./src/aframe/aframe-base.js